import { api } from "@/builders/axios";

const get = function (code: string) {
  return api.get<{
    name: string;
    description: string;
  }>(`setup/subjects/${code}`);
};

const put = function (
  code: string,
  data: { name: string; description: string }
) {
  return api.put(`/setup/subjects/${code}`, data);
};

const patch = function (
  code: string,
  data: Partial<{ name: string; description: string }>
) {
  return api.patch(`/setup/subjects/${code}`, data);
};

const del = function (code: string) {
  return api.delete(`/setup/subjects/${code}`);
};

export const code = {
  get,
  put,
  patch,
  del,
};
